module.exports = __webpack_public_path__ + "static/media/approved-icon.9c241b8e.svg";